module.exports = __webpack_public_path__ + "static/img/15075B_3_R_20200428_LC.d4fc401.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/15075B_3_R_20200428_LC.png
// module id = H8c5
// module chunks = 0